import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.59375 3.28125L0.28125 10.5938C0.09375 10.7812 0 10.9688 0 11.25V14.0625C0 14.625 0.375 15 0.9375 15H3.75C4.03125 15 4.21875 14.9062 4.40625 14.7188L11.7188 7.40625L7.59375 3.28125Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.7188 3.09375L11.9062 0.28125C11.5312 -0.09375 10.9688 -0.09375 10.5938 0.28125L8.90625 1.96875L13.0312 6.09375L14.7188 4.40625C15.0938 4.03125 15.0938 3.46875 14.7188 3.09375Z",
		fill: "currentColor"
	})]
});
export default SvgIconEdit;
